import { Chip } from "@kirvanobr/chip";
import { XClose } from "@untitled-ui/icons-react";
import { Tooltip } from "@kirvanobr/tooltip";
import { Typography } from "@kirvanobr/typography";

import { FilterChipProps } from "./FilterChip.types";

export const FilterChip = ({ children, data, ...otherProps }: FilterChipProps) => {
  const isLargeContent = data.label.length > 50;

  return (
    <Chip
      variant="outlined"
      color="default"
      size="lg"
      radius="sm"
      isCloseable
      {...otherProps}
      endContent={<XClose />}
      classNames={{
        base: "border h-10 gap-2 rounded-[4px]",
        closeButton: "",
      }}
    >
      <div>
        {isLargeContent ? (
          <Tooltip
            showArrow
            placement="top"
            color="primary"
            content={
              <Typography size="t5" color="tertiary">
                {data.label}
              </Typography>
            }
          >
            <button className="max-w-[350px] md:max-w-[450px] text-ellipsis overflow-hidden whitespace-nowrap cursor-default">
              {data.label}
            </button>
          </Tooltip>
        ) : (
          <div>{data.label}</div>
        )}
      </div>
      {children}
    </Chip>
  );
};
